



































































import Enumerable from "linq";
import { Mixins, Component, Prop } from "vue-property-decorator";
import { EditorItemMixin } from "./mixins";
import { ModelEditableMixin } from "../../../system/mixins";
import { ReceptionApplicant } from "../../../../domain/workflow/reception";
import { ReceptionTypeItem } from "../../../../domain/workflow/items";
import ComboBoxSelector from "../../../system/selectors/ComboBoxSelector.vue";

@Component({
  components: {
    ComboBoxSelector
  }
})
export default class ReceptionApplicantEditor extends Mixins(EditorItemMixin, ModelEditableMixin) {
  // ModelEditableMixinに実体あり
  editingSource: ReceptionApplicant;

  @Prop()
  relationshipItems: ReceptionTypeItem[];

  @Prop()
  hasNewPhoneNumber: boolean;
  
  @Prop()
  hasNewZipCode: boolean;

  @Prop()
  hasNewAddress: boolean;

  @Prop()
  isAddressTypeEnable: boolean;

  data(): any {
    return {
      relationships: [],
    };
  }
  // 選択肢設定が変更された場合を考慮して算出プロパティにしない
  // this.relationshipが"選択肢にない項目"を選択している状態(依頼登録後に設定変更した場合に起こる)のときに
  // 編集でthis.relationshipを"選択肢にある項目"に変更したとき、元の"選択肢にない項目"に戻せなくなるため
  relationships: string[];

  mounted(): void {
    this.relationships = this.toRelationships(this.relationshipItems);
  }

  get name(): string {
    return this.editingSource.name;
  }

  set name(value: string) {
    this.writeProperty((c: ReceptionApplicant) => (c.name = value));
  }

  get relationship(): string {
    return this.editingSource.relationship;
  }

  set relationship(value: string) {
    this.writeProperty((c: ReceptionApplicant) => (c.relationship = value));
  }

  get zipCode(): string {
    return this.editingSource.zipCode;
  }

  set zipCode(value: string) {
    this.writeProperty((c: ReceptionApplicant) => (c.zipCode = value));
  }

  get phoneNumber(): string {
    return this.editingSource.phoneNumber;
  }

  set phoneNumber(value: string) {
    this.writeProperty((c: ReceptionApplicant) => (c.phoneNumber = value));
  }

  get cellPhone(): string {
    return this.editingSource.cellPhone;
  }

  set cellPhone(value: string) {
    this.writeProperty((c: ReceptionApplicant) => (c.cellPhone = value));
  }

  get address(): string {
    return this.editingSource.address;
  }

  set address(value: string) {
    this.writeProperty((c: ReceptionApplicant) => (c.address = value));
  }

  get email(): string {
    return this.editingSource.email;
  }

  set email(value: string) {
    this.writeProperty((c: ReceptionApplicant) => (c.email = value));
  }

  get isPatientAddress(): boolean {
    return this.editingSource.isPatientAddress;
  }

  set isPatientAddress(value: boolean) {
    this.writeProperty((c: ReceptionApplicant) => (c.isPatientAddress = value));
  }

  get phoneNumberStyle(): any {
    return {
      color: this.hasNewPhoneNumber ? this.noticeIndicationColor : null,
      backgroundColor: this.hasNewPhoneNumber ? this.noticeIndicationBackgroundColor : null,
    };
  }

  get zipCodeStyle(): any {
    return {
      color: this.hasNewZipCode ? this.noticeIndicationColor : null,
      backgroundColor: this.hasNewZipCode ? this.noticeIndicationBackgroundColor : null,
    };
  }

  get addressStyle(): any {
    return {
      color: this.hasNewAddress ? this.noticeIndicationColor : null,
      backgroundColor: this.hasNewAddress ? this.noticeIndicationBackgroundColor : null,
    };
  }

  get noticeIndicationColor(): string {
    return this.$configuration.style.noticeIndication.color;
  }

  get noticeIndicationBackgroundColor(): string {
    return this.$configuration.style.noticeIndication.backgroundColor;
  }

  toRelationships(items: ReceptionTypeItem[]): string[] {
    // isDisable=false もしくは編集時に選択されている続柄を表示
    return Enumerable.from(items)
      .where(r => !r.isDisable || (this.relationship && r.name === this.relationship))
      .select(r => r.name)
      .toArray();
  }

  searchWithZipCode(): void {
    this.$commonDialogs.postalAddress.picker.pick(this.zipCode, !this.address)
    .then(result => {
      if (!result) { return; }
      this.writeProperty((c: ReceptionApplicant) => {
        c.zipCode = result.postalCode;
        c.address = result.prefecture + result.municipality + result.area;
      });
    })
    .catch(e => {
      this.$error("郵便番号検索エラー", "郵便番号検索処理中にエラーが発生しました。", e);
    });
  }
}
